module.exports = require('./components/Pagination.vue')



// WEBPACK FOOTER //
// ./src/plugins/vue-bootstrap-paginator/src/main.js